import { render, staticRenderFns } from "./PAQuoteList.vue?vue&type=template&id=7f4c4eb0&"
import script from "./PAQuoteList.vue?vue&type=script&lang=js&"
export * from "./PAQuoteList.vue?vue&type=script&lang=js&"
import style0 from "./PAQuoteList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PAQuoteList.vue"
export default component.exports